import { useEffect, useState } from "react";
import { _AdquisitionPlan, _single } from "../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../core/services/dataBean/useDataBean";
import { set } from "date-fns";

interface Props {
    idSelector: number;
    onChange: any;
    idAccount?: number;
    label?: string;
}

export const SelectAdquisitionPlanOnHiringState = ({ idSelector, onChange, label, idAccount }: Props) => {

    const { instance, lista, setLista } = useDataBean(_AdquisitionPlan);
    const [id, setID] = useState(idSelector ?? "");

    useEffect(() => {
        if (idSelector !== id) {
            setID(idSelector);
        }
    }, [idSelector])

    useEffect(() => {
        getLista();
    }, [])

    const setValue = (e: any) => {
        if (e == "") {
            setID("");
            onChange(null);
        } else {
            setID(e);
            onChange(e);
        }
    }

    const getLista = () => {
        instance.getAdquisitionPlanOnHiringState(idAccount ?? _single.getAccountID()).then(
            (resp: any) => {
                setLista(resp);
                console.log(resp);
            }
        );
    }

    return (
        <>
            <label>{label ?? "Plan de compras"}</label>
            <select name="IDAdquisitionPlan" className="form-select" value={id} onChange={(e) => { setValue(e.target.value); }} >
                <option value="">...</option>
                {lista.map((item: any, index: number) => {
                    return (
                        <option key={index} value={item.DataBeanProperties.IDAdquisitionPlan}>
                            {item.DataBeanProperties.Description}
                        </option>
                    );
                })}
            </select>
        </>
    )
}